export function deleteFocus(form, id) {
  const curAdditionalFocuses = form.getState().values.additionalFocuses
  const nextAdditionalFocuses = curAdditionalFocuses.filter(curFocus => curFocus.id !== id)
  form.change('additionalFocuses', nextAdditionalFocuses)
};
